function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionsChangeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m6.1994 12.261a0.69762 0.69762 0 0 0-0.69727 0.69727 0.69762 0.69762 0 0 0 0.69727 0.69727h8.7461a0.69762 0.69762 0 0 0 0.69726-0.69727 0.69762 0.69762 0 0 0-0.69726-0.69727z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    fill: "#999",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.692 8.128a0.69762 0.69762 0 0 0-0.47852 0.20508 0.69762 0.69762 0 0 0 0 0.98633l3.6367 3.6387-3.6367 3.6387a0.69762 0.69762 0 0 0 0 0.98633 0.69762 0.69762 0 0 0 0.98633 0l4.1309-4.1328a0.69769 0.69769 0 0 0 0-0.98633l-4.1309-4.1309a0.69762 0.69762 0 0 0-0.50781-0.20508z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    fill: "#999",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsChangeArrow);
export default __webpack_public_path__ + "static/media/optionsChangeArrow.df3687692a017befedf8183c8c332bae.svg";
export { ForwardRef as ReactComponent };